if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 768px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      // onSlideChanged(event) {
      //   if (event.detail && event.detail.currentElement) {
      //     const currentElement = event.detail.currentElement;
      //     if (currentElement.dataset && currentElement.dataset.mediaId) {
      //       const thumbnail = this.elements.thumbnails.querySelector(
      //         `[data-target="${currentElement.dataset.mediaId}"]`
      //       );
      //       this.setActiveThumbnail(thumbnail);
      //     }
      //   }
      // }
      // onSlideChanged(event) {
      //   if (event.detail && event.detail.currentElement) {
      //     const currentElement = event.detail.currentElement;
      //     if (currentElement.dataset && currentElement.dataset.mediaId) {
      //       // Prevent resetting to the first image if a variant was selected
      //       if (this.elements.viewer.dataset.selectedMediaId && 
      //           this.elements.viewer.dataset.selectedMediaId !== currentElement.dataset.mediaId) {
      //           return;
      //       }
      //       const thumbnail = this.elements.thumbnails.querySelector(
      //           `[data-target="${currentElement.dataset.mediaId}"]`
      //       );
      //       this.setActiveThumbnail(thumbnail);
      //     }
      //   }
      // }
      // onSlideChanged(event) {
      //   if (event.detail && event.detail.currentElement) {
      //     const currentElement = event.detail.currentElement;
          
      //     // 【新增代码】: 确保滑动到当前幻灯片时，触发视频/3D模型的加载
      //     this.playActiveMedia(currentElement);

      //     if (currentElement.dataset && currentElement.dataset.mediaId) {
      //       // Prevent resetting to the first image if a variant was selected
      //       if (this.elements.viewer.dataset.selectedMediaId && 
      //           this.elements.viewer.dataset.selectedMediaId !== currentElement.dataset.mediaId) {
      //           return;
      //       }
      //       const thumbnail = this.elements.thumbnails.querySelector(
      //           `[data-target="${currentElement.dataset.mediaId}"]`
      //       );
      //       this.setActiveThumbnail(thumbnail);
      //     }
      //   }
      // }
      onSlideChanged(event) {
        if (!event.detail || !event.detail.currentElement) return;

        const currentElement = event.detail.currentElement;

        // 【关键步骤 1】：无论如何，先强制把 <template> 里的代码渲染成真正的 <video>，并尝试播放
        this.playActiveMedia(currentElement);

        if (currentElement.dataset && currentElement.dataset.mediaId) {
          // 【关键步骤 2】：滑动后，必须把程序记录的“当前ID”更新为新滑到的这页的ID
          // 之前就是因为缺了这一句，导致原来的 return 把视频加载逻辑给截断了！
          this.elements.viewer.dataset.selectedMediaId = currentElement.dataset.mediaId;

          // 【关键步骤 3】：同步底部缩略图的高亮状态
          if (this.elements.thumbnails) {
            const thumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${currentElement.dataset.mediaId}"]`
            );
            if (thumbnail) {
              this.setActiveThumbnail(thumbnail);
            }
          }
        }
      }
      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
        }
        this.elements.viewer.dataset.selectedMediaId = mediaId;
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.setSlidePosition(thumbnail[this.elements.thumbnails.offsetLeft]);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      // playActiveMedia(activeItem) {
      //   window.pauseAllMedia();
      //   const deferredMedia = activeItem.querySelector('.deferred-media');
      //   if (deferredMedia) deferredMedia.loadContent(false);
      // }
  
      // playActiveMedia(activeItem) {
      //   // 先暂停页面上其他正在播放的媒体
      //   window.pauseAllMedia();
        
      //   const deferredMedia = activeItem.querySelector('.deferred-media');
      //   if (deferredMedia) {
      //     // 确保视频 DOM 已被加载
      //     deferredMedia.loadContent(false);

      //     // 稍微延迟一点，等待 DOM 渲染完成，然后强制播放
      //     setTimeout(() => {
      //       // 1. 处理原生 HTML5 视频 (MP4)
      //       const nativeVideo = deferredMedia.querySelector('video');
      //       if (nativeVideo) {
      //         // 使用 catch 捕获浏览器（如 Safari）可能因为静音策略拦截自动播放的报错
      //         nativeVideo.play().catch((e) => {
      //           console.warn("浏览器策略限制了自动播放，需用户手动交互", e);
      //         });
      //       }

      //       // 2. 处理 YouTube 视频 (通过 postMessage 发送 API 指令)
      //       const youtubeVideo = deferredMedia.querySelector('.js-youtube');
      //       if (youtubeVideo) {
      //         youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      //       }

      //       // 3. 处理 Vimeo 视频
      //       const vimeoVideo = deferredMedia.querySelector('.js-vimeo');
      //       if (vimeoVideo) {
      //         vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*');
      //       }
      //     }, 50); 
      //   }
      // }
      playActiveMedia(activeItem) {
        // 1. 先暂停页面上其他正在播放的视频，防止声音/画面混乱
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }
        
        // 2. 兼容 3D 模型的加载逻辑（因为 3D 模型依然保留了 deferred-media）
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }

        // 3. 【核心修复】：直接查找幻灯片内的真实视频标签并强制下达播放指令
        setTimeout(() => {
          // 处理原生 HTML5 视频 (MP4)
          const nativeVideo = activeItem.querySelector('video');
          if (nativeVideo) {
            nativeVideo.play().catch((e) => {
              console.warn("浏览器策略限制了自动播放，需用户手动交互", e);
            });
          }

          // 处理 YouTube 视频 (通过 iframe postMessage 发送指令)
          const youtubeVideo = activeItem.querySelector('.js-youtube');
          if (youtubeVideo && youtubeVideo.contentWindow) {
            youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }

          // 处理 Vimeo 视频
          const vimeoVideo = activeItem.querySelector('.js-vimeo');
          if (vimeoVideo && vimeoVideo.contentWindow) {
            vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*');
          }
        }, 50); // 稍微延迟 50ms 确保 DOM 已经完全准备好
      }
      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
